//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
    private get token() {
        const tokenJson = sessionStorage.getItem(
            `oidc.user:${process.env.REACT_APP_OIDC_AUTHORITY}:${process.env.REACT_APP_OIDC_CLIENTID}`
        )
        const token = tokenJson ? JSON.parse(tokenJson) : null
        return token ? `Bearer ${token.access_token}` : ""
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
            ...options.headers,
            Authorization: this.token,
        }
        return Promise.resolve(options)
    }
}

export interface IActivityApplicationsClient {

    createAndUpdate(command: CreateAndUpdateActivityApplicationCommand): Promise<string>;

    createAttachment(activityApplicationId: string | null | undefined, attachmentType: string | null | undefined, file: FileParameter | null | undefined): Promise<string>;

    changeIsCompleted(command: ChangeActivityApplicationIsCompletedCommand): Promise<FileResponse>;
}

export class ActivityApplicationsClient extends AuthorizedApiBase implements IActivityApplicationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createAndUpdate(command: CreateAndUpdateActivityApplicationCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/ActivityApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAndUpdate(_response);
        });
    }

    protected processCreateAndUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    createAttachment(activityApplicationId: string | null | undefined, attachmentType: string | null | undefined, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ActivityApplications/CreateAttachment?";
        if (activityApplicationId !== undefined && activityApplicationId !== null)
            url_ += "activityApplicationId=" + encodeURIComponent("" + activityApplicationId) + "&";
        if (attachmentType !== undefined && attachmentType !== null)
            url_ += "attachmentType=" + encodeURIComponent("" + attachmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAttachment(_response);
        });
    }

    protected processCreateAttachment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    changeIsCompleted(command: ChangeActivityApplicationIsCompletedCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActivityApplications/ChangeIsCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeIsCompleted(_response);
        });
    }

    protected processChangeIsCompleted(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IActivityClient {

    createAndUpdate(command: CreateAndUpdateActivityCommand): Promise<string>;
}

export class ActivityClient extends AuthorizedApiBase implements IActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createAndUpdate(command: CreateAndUpdateActivityCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAndUpdate(_response);
        });
    }

    protected processCreateAndUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICentersClient {

    getList(userId: string | null | undefined): Promise<CenterBriefVm[]>;
}

export class CentersClient extends AuthorizedApiBase implements ICentersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getList(userId: string | null | undefined): Promise<CenterBriefVm[]> {
        let url_ = this.baseUrl + "/api/Centers?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<CenterBriefVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CenterBriefVm[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CenterBriefVm[]>(null as any);
    }
}

export interface IMembersClient {

    getList(memberNo: string | null | undefined, chineseName: string | null | undefined, englishName: string | null | undefined, mainContactNumber: string | null | undefined, emailAddress: string | null | undefined, birthdateFrom: Date | null | undefined, birthdateTo: Date | null | undefined, isFromB2C: boolean | null | undefined, membershipTypeIds: number[] | undefined, orderBy: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfMemberInfoBriefVm>;

    getEmergencyContacts(memberId: string | null, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfEmergencyContactVm>;

    get(memberId: string | null): Promise<MemberInfoVm>;

    getUserdefinedValues(memberId: string | null): Promise<{ [key: string]: any; }>;

    getSurvey(memberId: string | null): Promise<MemberSurveyVm[]>;

    getCurrent(): Promise<MemberInfoDto>;

    createVolunteerMeetingRecord(command: CreateVolunteerMeetingRecordCommand): Promise<string>;

    updateVolunteerMeetingRecord(id: string | null, command: UpdateVolunteerMeetingRecordCommand): Promise<FileResponse>;

    createVolunteerMeetingRecordAttachment(volunteerMeetingRecordId: string | null | undefined, description: string | null | undefined, file: FileParameter | null | undefined): Promise<number>;

    createPSW(command: CreatePSWCommand): Promise<string>;

    updatePSW(id: string | null, command: UpdatePSWCommand): Promise<FileResponse>;

    createPSWAttachment(pswId: string | null | undefined, description: string | null | undefined, file: FileParameter | null | undefined): Promise<number>;
}

export class MembersClient extends AuthorizedApiBase implements IMembersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getList(memberNo: string | null | undefined, chineseName: string | null | undefined, englishName: string | null | undefined, mainContactNumber: string | null | undefined, emailAddress: string | null | undefined, birthdateFrom: Date | null | undefined, birthdateTo: Date | null | undefined, isFromB2C: boolean | null | undefined, membershipTypeIds: number[] | undefined, orderBy: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfMemberInfoBriefVm> {
        let url_ = this.baseUrl + "/api/Members?";
        if (memberNo !== undefined && memberNo !== null)
            url_ += "MemberNo=" + encodeURIComponent("" + memberNo) + "&";
        if (chineseName !== undefined && chineseName !== null)
            url_ += "ChineseName=" + encodeURIComponent("" + chineseName) + "&";
        if (englishName !== undefined && englishName !== null)
            url_ += "EnglishName=" + encodeURIComponent("" + englishName) + "&";
        if (mainContactNumber !== undefined && mainContactNumber !== null)
            url_ += "MainContactNumber=" + encodeURIComponent("" + mainContactNumber) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (birthdateFrom !== undefined && birthdateFrom !== null)
            url_ += "BirthdateFrom=" + encodeURIComponent(birthdateFrom ? "" + birthdateFrom.toISOString() : "") + "&";
        if (birthdateTo !== undefined && birthdateTo !== null)
            url_ += "BirthdateTo=" + encodeURIComponent(birthdateTo ? "" + birthdateTo.toISOString() : "") + "&";
        if (isFromB2C !== undefined && isFromB2C !== null)
            url_ += "IsFromB2C=" + encodeURIComponent("" + isFromB2C) + "&";
        if (membershipTypeIds === null)
            throw new Error("The parameter 'membershipTypeIds' cannot be null.");
        else if (membershipTypeIds !== undefined)
            membershipTypeIds && membershipTypeIds.forEach(item => { url_ += "MembershipTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isOrderByAscending === null)
            throw new Error("The parameter 'isOrderByAscending' cannot be null.");
        else if (isOrderByAscending !== undefined)
            url_ += "IsOrderByAscending=" + encodeURIComponent("" + isOrderByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<PaginatedListOfMemberInfoBriefVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfMemberInfoBriefVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMemberInfoBriefVm>(null as any);
    }

    getEmergencyContacts(memberId: string | null, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfEmergencyContactVm> {
        let url_ = this.baseUrl + "/api/Members/EmergencyContacts/{MemberId}?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{MemberId}", encodeURIComponent("" + memberId));
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isOrderByAscending === null)
            throw new Error("The parameter 'isOrderByAscending' cannot be null.");
        else if (isOrderByAscending !== undefined)
            url_ += "IsOrderByAscending=" + encodeURIComponent("" + isOrderByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmergencyContacts(_response);
        });
    }

    protected processGetEmergencyContacts(response: Response): Promise<PaginatedListOfEmergencyContactVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfEmergencyContactVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfEmergencyContactVm>(null as any);
    }

    get(memberId: string | null): Promise<MemberInfoVm> {
        let url_ = this.baseUrl + "/api/Members/{MemberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{MemberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MemberInfoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberInfoVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoVm>(null as any);
    }

    getUserdefinedValues(memberId: string | null): Promise<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/Members/UserDefinedValues/{MemberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{MemberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserdefinedValues(_response);
        });
    }

    protected processGetUserdefinedValues(response: Response): Promise<{ [key: string]: any; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: any; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }>(null as any);
    }

    getSurvey(memberId: string | null): Promise<MemberSurveyVm[]> {
        let url_ = this.baseUrl + "/api/Members/Survey/{MemberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{MemberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSurvey(_response);
        });
    }

    protected processGetSurvey(response: Response): Promise<MemberSurveyVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberSurveyVm[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberSurveyVm[]>(null as any);
    }

    getCurrent(): Promise<MemberInfoDto> {
        let url_ = this.baseUrl + "/api/Members/Current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrent(_response);
        });
    }

    protected processGetCurrent(response: Response): Promise<MemberInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberInfoDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoDto>(null as any);
    }

    createVolunteerMeetingRecord(command: CreateVolunteerMeetingRecordCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Members/VolunteerMeetingRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVolunteerMeetingRecord(_response);
        });
    }

    protected processCreateVolunteerMeetingRecord(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateVolunteerMeetingRecord(id: string | null, command: UpdateVolunteerMeetingRecordCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Members/VolunteerMeetingRecord/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVolunteerMeetingRecord(_response);
        });
    }

    protected processUpdateVolunteerMeetingRecord(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createVolunteerMeetingRecordAttachment(volunteerMeetingRecordId: string | null | undefined, description: string | null | undefined, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Members/VolunteerMeetingRecordAttachment?";
        if (volunteerMeetingRecordId !== undefined && volunteerMeetingRecordId !== null)
            url_ += "volunteerMeetingRecordId=" + encodeURIComponent("" + volunteerMeetingRecordId) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVolunteerMeetingRecordAttachment(_response);
        });
    }

    protected processCreateVolunteerMeetingRecordAttachment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createPSW(command: CreatePSWCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Members/PSW";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePSW(_response);
        });
    }

    protected processCreatePSW(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updatePSW(id: string | null, command: UpdatePSWCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Members/PSW/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePSW(_response);
        });
    }

    protected processUpdatePSW(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createPSWAttachment(pswId: string | null | undefined, description: string | null | undefined, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Members/PSWAttachment?";
        if (pswId !== undefined && pswId !== null)
            url_ += "pswId=" + encodeURIComponent("" + pswId) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePSWAttachment(_response);
        });
    }

    protected processCreatePSWAttachment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IMembershipTypesClient {

    getList(): Promise<MembershipTypeDto[]>;
}

export class MembershipTypesClient extends AuthorizedApiBase implements IMembershipTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getList(): Promise<MembershipTypeDto[]> {
        let url_ = this.baseUrl + "/api/MembershipTypes/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<MembershipTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MembershipTypeDto[]>(null as any);
    }
}

export interface IMemberSurveysClient {

    getList(memberInfoId: string | null | undefined, formType: AssessmentType2 | undefined): Promise<SurveyFirstAndLastDto[]>;

    get(id: number): Promise<MemberSurveyDto>;

    update(id: number, command: UpdateMemberSurveyCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    getSurveyVersion(surveyId: string | null | undefined): Promise<SurveyVersionDetailDto>;

    search(query: SearchMemberSurveyHistorysWithPaginationQuery): Promise<PaginatedListOfMemberSurveyLabelDto>;

    searchMemberSurveys(query: SearchMemberSurveysWithPaginationQuery): Promise<PaginatedListOfMemberSurveyDto>;

    create(command: CreateMemberSurveyCommand): Promise<number>;
}

export class MemberSurveysClient extends AuthorizedApiBase implements IMemberSurveysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getList(memberInfoId: string | null | undefined, formType: AssessmentType2 | undefined): Promise<SurveyFirstAndLastDto[]> {
        let url_ = this.baseUrl + "/api/MemberSurveys/GetList?";
        if (memberInfoId !== undefined && memberInfoId !== null)
            url_ += "memberInfoId=" + encodeURIComponent("" + memberInfoId) + "&";
        if (formType === null)
            throw new Error("The parameter 'formType' cannot be null.");
        else if (formType !== undefined)
            url_ += "formType=" + encodeURIComponent("" + formType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<SurveyFirstAndLastDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyFirstAndLastDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyFirstAndLastDto[]>(null as any);
    }

    get(id: number): Promise<MemberSurveyDto> {
        let url_ = this.baseUrl + "/api/MemberSurveys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MemberSurveyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberSurveyDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberSurveyDto>(null as any);
    }

    update(id: number, command: UpdateMemberSurveyCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MemberSurveys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MemberSurveys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSurveyVersion(surveyId: string | null | undefined): Promise<SurveyVersionDetailDto> {
        let url_ = this.baseUrl + "/api/MemberSurveys/GetSurveyVersion?";
        if (surveyId !== undefined && surveyId !== null)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSurveyVersion(_response);
        });
    }

    protected processGetSurveyVersion(response: Response): Promise<SurveyVersionDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyVersionDetailDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyVersionDetailDto>(null as any);
    }

    search(query: SearchMemberSurveyHistorysWithPaginationQuery): Promise<PaginatedListOfMemberSurveyLabelDto> {
        let url_ = this.baseUrl + "/api/MemberSurveys/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginatedListOfMemberSurveyLabelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfMemberSurveyLabelDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMemberSurveyLabelDto>(null as any);
    }

    searchMemberSurveys(query: SearchMemberSurveysWithPaginationQuery): Promise<PaginatedListOfMemberSurveyDto> {
        let url_ = this.baseUrl + "/api/MemberSurveys/SearchMemberSurveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchMemberSurveys(_response);
        });
    }

    protected processSearchMemberSurveys(response: Response): Promise<PaginatedListOfMemberSurveyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfMemberSurveyDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMemberSurveyDto>(null as any);
    }

    create(command: CreateMemberSurveyCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/MemberSurveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ISurveysClient {

    get(id: string | null): Promise<SurveyDto>;

    search(query: SearchSurveysWithPaginationQuery): Promise<PaginatedListOfSurveyDto>;

    getAssessmentTypeList(): Promise<AssessmentTypeDto[]>;
}

export class SurveysClient extends AuthorizedApiBase implements ISurveysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string | null): Promise<SurveyDto> {
        let url_ = this.baseUrl + "/api/Surveys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SurveyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyDto>(null as any);
    }

    search(query: SearchSurveysWithPaginationQuery): Promise<PaginatedListOfSurveyDto> {
        let url_ = this.baseUrl + "/api/Surveys/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginatedListOfSurveyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfSurveyDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSurveyDto>(null as any);
    }

    getAssessmentTypeList(): Promise<AssessmentTypeDto[]> {
        let url_ = this.baseUrl + "/api/Surveys/GetAssessmentTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTypeList(_response);
        });
    }

    protected processGetAssessmentTypeList(response: Response): Promise<AssessmentTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssessmentTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentTypeDto[]>(null as any);
    }
}

export interface IUsersClient {

    getList(volunteerId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfUserProfileVm>;

    get(userId: string | null): Promise<UserProfileVm>;
}

export class UsersClient extends AuthorizedApiBase implements IUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getList(volunteerId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAscending: boolean | undefined): Promise<PaginatedListOfUserProfileVm> {
        let url_ = this.baseUrl + "/api/Users?";
        if (volunteerId === null)
            throw new Error("The parameter 'volunteerId' cannot be null.");
        else if (volunteerId !== undefined)
            url_ += "VolunteerId=" + encodeURIComponent("" + volunteerId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAscending === null)
            throw new Error("The parameter 'isOrderByAscending' cannot be null.");
        else if (isOrderByAscending !== undefined)
            url_ += "IsOrderByAscending=" + encodeURIComponent("" + isOrderByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<PaginatedListOfUserProfileVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedListOfUserProfileVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfUserProfileVm>(null as any);
    }

    get(userId: string | null): Promise<UserProfileVm> {
        let url_ = this.baseUrl + "/api/Users/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserProfileVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileVm>(null as any);
    }
}

export interface IVolunteersClient {

    getVolunteerPrograms(volunteerId: number): Promise<VolunteerProgramVm[]>;

    getPracticumHour(volunteerId: number, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAscending: boolean | undefined): Promise<VolunteerTotalServiceHourVm>;

    createPracticumHour(command: CreateVolunteerPracticumHourCommand): Promise<string>;
}

export class VolunteersClient extends AuthorizedApiBase implements IVolunteersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVolunteerPrograms(volunteerId: number): Promise<VolunteerProgramVm[]> {
        let url_ = this.baseUrl + "/api/Volunteers/VolunteerPrograms/{VolunteerId}";
        if (volunteerId === undefined || volunteerId === null)
            throw new Error("The parameter 'volunteerId' must be defined.");
        url_ = url_.replace("{VolunteerId}", encodeURIComponent("" + volunteerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVolunteerPrograms(_response);
        });
    }

    protected processGetVolunteerPrograms(response: Response): Promise<VolunteerProgramVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerProgramVm[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerProgramVm[]>(null as any);
    }

    getPracticumHour(volunteerId: number, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAscending: boolean | undefined): Promise<VolunteerTotalServiceHourVm> {
        let url_ = this.baseUrl + "/api/Volunteers/PracticumHour/{VolunteerId}?";
        if (volunteerId === undefined || volunteerId === null)
            throw new Error("The parameter 'volunteerId' must be defined.");
        url_ = url_.replace("{VolunteerId}", encodeURIComponent("" + volunteerId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAscending === null)
            throw new Error("The parameter 'isOrderByAscending' cannot be null.");
        else if (isOrderByAscending !== undefined)
            url_ += "IsOrderByAscending=" + encodeURIComponent("" + isOrderByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPracticumHour(_response);
        });
    }

    protected processGetPracticumHour(response: Response): Promise<VolunteerTotalServiceHourVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerTotalServiceHourVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerTotalServiceHourVm>(null as any);
    }

    createPracticumHour(command: CreateVolunteerPracticumHourCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Volunteers/PracticumHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePracticumHour(_response);
        });
    }

    protected processCreatePracticumHour(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface CreateAndUpdateActivityApplicationCommand {
    activityId?: string;
    applications?: ActivityApplicationItem[];
}

export interface ActivityApplicationItem {
    memberNo?: string;
    applicationTime?: Date;
    attendance?: boolean;
    completeAt?: Date | undefined;
    latestActivityOrStatus?: string | undefined;
}

export interface ChangeActivityApplicationIsCompletedCommand {
    activityId?: string;
    memberNo?: string;
    isCompleted?: boolean;
}

export interface CreateAndUpdateActivityCommand {
    id?: string;
    activityProject?: string;
    activityName?: string;
    language?: string;
    displayDate?: Date;
    activityDateTime?: Date | undefined;
    status?: string;
    actualDateFrom?: Date | undefined;
    actualDateTo?: Date | undefined;
    url?: string | undefined;
    type?: string;
    emotionCategory?: string;
    hashtag?: string;
    bannerVideoLink?: string | undefined;
    numberOfPeople?: number;
    onAirDate?: Date | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    applicantTypes?: string[];
    applicationURL?: string | undefined;
    workshopLink?: string | undefined;
    enrollmentType?: string | undefined;
    programCode?: string | undefined;
    programMode?: string;
    activityType?: string | undefined;
    relatedELearningCourseId?: string | undefined;
}

export interface CenterBriefVm {
    centerId?: number;
    abbreviation?: string;
    chineseTitle?: string | undefined;
    englishTitle?: string | undefined;
}

export interface PaginatedListOfMemberInfoBriefVm {
    items?: MemberInfoBriefVm[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface MemberInfoBriefVm {
    memberId?: string;
    memberNo?: string;
    chineseName?: string;
    englishName?: string;
    birthdate?: Date | undefined;
    ageCurrent?: number | undefined;
    ageAdmitted?: number | undefined;
    district?: string | undefined;
    isCarer?: boolean | undefined;
    mainContactNumber?: string;
    emailAddress?: string | undefined;
    url?: string;
    volunteerId?: number | undefined;
    volunteerServiceExperience?: string | undefined;
    isFromB2C?: boolean;
    marital?: any | undefined;
    occupation?: any | undefined;
    gender?: any | undefined;
    educationLevel?: any | undefined;
    memberships?: string[];
}

export interface PaginatedListOfEmergencyContactVm {
    items?: EmergencyContactVm[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface EmergencyContactVm {
    relationship?: string;
    chineseName?: string;
    englishName?: string;
    mainContactNumber?: string;
    otherContactNumber?: string | undefined;
}

export interface MemberInfoVm {
    memberId?: string;
    memberNo?: string;
    chineseName?: string;
    englishName?: string;
    birthdate?: Date | undefined;
    age?: number | undefined;
    district?: string | undefined;
    isCarer?: boolean | undefined;
    mainContactNumber?: string;
    emailAddress?: string | undefined;
    volunteerServiceExperience?: string | undefined;
    volunteerId?: number | undefined;
    url?: string;
    isFromB2C?: boolean;
    memberships?: string[];
}

export interface MemberSurveyVm {
    formName?: string;
    content?: string | undefined;
    created?: Date;
    assessmentItemDetails?: SurveyAssessmentCriteriaDetailVm[];
}

export interface SurveyAssessmentCriteriaDetailVm {
    assessmentItem?: string;
    score?: string;
    result?: string;
}

export interface BaseEntityOfString {
    id?: string;
    domainEvents?: BaseEvent[];
}

export interface BaseAuditableEntityOfString extends BaseEntityOfString {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export interface BaseMaskMemberInfoOfString extends BaseAuditableEntityOfString {
    chineseName?: string | undefined;
    englishName?: string | undefined;
    nickname?: string | undefined;
    hongKongIdentityCardNumber?: string | undefined;
    birthdate?: Date | undefined;
    maskBirthdate?: string | undefined;
    mainContactNumber?: string | undefined;
    otherContactNumber?: string | undefined;
}

export interface MemberInfoDto extends BaseMaskMemberInfoOfString {
    memberNo?: string;
    ageCurrent?: number | undefined;
    ageAdmitted?: number | undefined;
    emailAddress?: string | undefined;
    remarks1?: string | undefined;
    remarks2?: string | undefined;
    address?: AddressDto | undefined;
    isDeleted?: boolean;
    isVolunteer?: boolean;
    isCarer?: boolean | undefined;
    memberships?: MembershipBriefDto[];
    memberInfoUserDefinedValues?: MemberInfoUserDefinedValueDto[];
    yearToHongKong?: number | undefined;
    numberOfChildren?: number | undefined;
    ageOfChildren?: string | undefined;
    nameOfSchoolOrCompany?: string | undefined;
    addressOfSchoolOrCompany?: string | undefined;
    otherRemarks1?: string | undefined;
    otherRemarks2?: string | undefined;
    otherRemarks3?: string | undefined;
    otherRemarks4?: string | undefined;
    otherRemarks5?: string | undefined;
    otherRemarks6?: string | undefined;
    newsletterRemarks1?: string | undefined;
    newsletterRemarks2?: string | undefined;
    isExternalLoginEnabled?: boolean;
    subscriptionChoice?: boolean;
    volunteerId?: number | undefined;
    isFromB2C?: boolean;
    dateOfSuspectedToKnow?: Date | undefined;
    currentlyReceivingPsychiatricTreatment?: boolean | undefined;
    nameOfHospitalOrClinic?: string | undefined;
    keyCaseWorkerForFamilyUserId?: string | undefined;
    keyCaseWorkerForFamilyUserEnglishName?: string | undefined;
    haveVolunteerRecord?: boolean;
    individualSupportFriendlyVisit?: boolean | undefined;
    individualSupportWarmOrPhoneOrBirthdayCall?: boolean | undefined;
    individualSupportOthers?: boolean | undefined;
    individualSupportOthersFreeText?: string | undefined;
    friendlyVistFrequency?: string | undefined;
    friendlyVistFrequencyFreeText?: string | undefined;
    warmOrPhoneOrBirthdayCallFrequency?: string | undefined;
    warmOrPhoneOrBirthdayCallFrequencyFreeText?: string | undefined;
    othersFrequency?: string | undefined;
    othersFrequencyFreeText?: string | undefined;
    personalInformationPermission?: PersonalInformationPermission;
    caseworkPermission?: NonCaseworkOrCaseworkPermission;
    nonCaseworkPermission?: NonCaseworkOrCaseworkPermission;
}

export interface AddressDto {
    inputtedAddress?: string | undefined;
    block?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    buildingId?: number | undefined;
    region?: string | undefined;
    district?: string | undefined;
    subDistrict?: string | undefined;
    street?: string | undefined;
    estate?: string | undefined;
    building?: string | undefined;
    fullAddress?: string;
}

export interface BaseEntityOfInteger {
    id?: number;
    domainEvents?: BaseEvent[];
}

export interface BaseAuditableEntityOfInteger extends BaseEntityOfInteger {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export interface MembershipBriefDto extends BaseAuditableEntityOfInteger {
    membershipTypeId?: number;
    admittedDate?: Date;
    expiryDate?: Date | undefined;
    exitDate?: Date | undefined;
    membershipTypeName?: string;
    isDeleted?: boolean;
    isTransferred?: boolean;
    status?: MembershipStatus;
    serviceUnitId?: string;
    serviceUnitAbbreviation?: string;
    centerId?: number;
    centerAbbreviation?: string;
    teamId?: number;
    teamAbbreviation?: string;
    membershipSubTypeId?: number | undefined;
    membershipSubTypeNmae?: string | undefined;
    subCenter?: SubCenter | undefined;
}

export enum MembershipStatus {
    Admitted = "Admitted",
    Exit = "Exit",
    Expired = "Expired",
    Deleted = "Deleted",
    Pending = "Pending",
}

export enum SubCenter {
    HKE = "HKE",
    EW = "EW",
}

export interface BaseEvent {
}

export interface MemberInfoUserDefinedValueDto extends BaseAuditableEntityOfInteger {
    memberInfoId?: string;
    userDefinedValueId?: number;
    userDefinedValue?: UserDefinedValueDto;
    remarks?: string | undefined;
}

export interface UserDefinedValueDto {
    id?: number;
    title?: string;
    sortOrder?: number;
    isEnabled?: boolean;
    hasRemarks?: boolean;
    isRemarksRequired?: boolean;
    category?: UserDefinedField;
    remarksCategory?: UserDefinedField | undefined;
    describe?: string | undefined;
}

export enum UserDefinedField {
    Gender = "Gender",
    SupervisorApprovalAction = "SupervisorApprovalAction",
    MentalStatus = "MentalStatus",
    MainDiagnosis = "MainDiagnosis",
    MaritalStatus = "MaritalStatus",
    LivingStatus = "LivingStatus",
    Availability = "Availability",
    Archive = "Archive",
    EducationLevel = "EducationLevel",
    CaseOwnerMentalStatus = "CaseOwnerMentalStatus",
    CaseOwnerMainDiagnosis = "CaseOwnerMainDiagnosis",
    ConsentFormOrNSRForm = "ConsentFormOrNSRForm",
    ReferralAgency = "ReferralAgency",
    AgencyDept = "AgencyDept",
    IsSelfApproachAMember = "IsSelfApproachAMember",
    EnquiryProfileContactNature = "EnquiryProfileContactNature",
    EnquiryType = "EnquiryType",
    KnowAboutThisServiceBy = "KnowAboutThisServiceBy",
    FollowUpbyBOKSS = "FollowUpbyBOKSS",
    DiagnosisStatus = "DiagnosisStatus",
    SuggestedService = "SuggestedService",
    EnquiryCategory = "EnquiryCategory",
    NeedCaseworkFollowUp = "NeedCaseworkFollowUp",
    EnquiryRisk = "EnquiryRisk",
    EnquiryReferralSource = "EnquiryReferralSource",
    EnquiryPendingCloseReason = "EnquiryPendingCloseReason",
    CaseInfoTag = "CaseInfoTag",
    EnquiryRecordingContactNature = "EnquiryRecordingContactNature",
    EnquiryRecordingJointVisitWith = "EnquiryRecordingJointVisitWith",
    ReferOutReferralTo = "ReferOutReferralTo",
    CaseIntervention = "CaseIntervention",
    CaseJourney = "CaseJourney",
    CaseIntakeContactNature = "CaseIntakeContactNature",
    CaseIntakeJointVisitWith = "CaseIntakeJointVisitWith",
    CurrentMedicalOrSocialService = "CurrentMedicalOrSocialService",
    CurrentPsychiatricDiagnosis = "CurrentPsychiatricDiagnosis",
    BehavioralObservationTime = "BehavioralObservationTime",
    BehavioralObservationAge = "BehavioralObservationAge",
    BehavioralObservationBuild = "BehavioralObservationBuild",
    BehavioralObservationClothing = "BehavioralObservationClothing",
    BehavioralObservationManner = "BehavioralObservationManner",
    BehavioralObservationMobility = "BehavioralObservationMobility",
    BehavioralObservationMood = "BehavioralObservationMood",
    BehavioralObservationAffect = "BehavioralObservationAffect",
    BehavioralObservationThoughtForm = "BehavioralObservationThoughtForm",
    ThoughtContectDelusionalThoughts = "ThoughtContectDelusionalThoughts",
    ThoughtContectSuicidalThoughts = "ThoughtContectSuicidalThoughts",
    ThoughtContectHomicidalThoughts = "ThoughtContectHomicidalThoughts",
    ThoughtContectReligiosity = "ThoughtContectReligiosity",
    ThoughtContectPhobias = "ThoughtContectPhobias",
    ThoughtContectIdeaOfGuiltOrhopelessnessOrworthlessness = "ThoughtContectIdeaOfGuiltOrhopelessnessOrworthlessness",
    ThoughtContectObsessions = "ThoughtContectObsessions",
    ThoughtContectBlamingOthers = "ThoughtContectBlamingOthers",
    ThoughtContectOthers = "ThoughtContectOthers",
    PerceptionsUndetected = "PerceptionsUndetected",
    PerceptionsAOrH = "PerceptionsAOrH",
    PerceptionsVOrH = "PerceptionsVOrH",
    PerceptionsTOrH = "PerceptionsTOrH",
    PerceptionsOOrH = "PerceptionsOOrH",
    PerceptionsGOrH = "PerceptionsGOrH",
    CognitionMemory = "CognitionMemory",
    CognitionDisorientation = "CognitionDisorientation",
    CognitionAbstractReasoning = "CognitionAbstractReasoning",
    CognitionInsight = "CognitionInsight",
    CognitionMotivationForRecovery = "CognitionMotivationForRecovery",
    CognitionConcentration = "CognitionConcentration",
    CognitionJudgement = "CognitionJudgement",
    CognitionIntellect = "CognitionIntellect",
    CognitionImpulseControl = "CognitionImpulseControl",
    CognitionAdherenceToMedication = "CognitionAdherenceToMedication",
    CaseAssessmentContactNature = "CaseAssessmentContactNature",
    CaseAssessmentJointVisitWith = "CaseAssessmentJointVisitWith",
    HavePhysicalHealthProblem = "HavePhysicalHealthProblem",
    PhysicalHealthProblem = "PhysicalHealthProblem",
    HaveProblemsOfSubstanceAbuseOrMisuse = "HaveProblemsOfSubstanceAbuseOrMisuse",
    ProblemsOfSubstanceAbuseOrMisuse = "ProblemsOfSubstanceAbuseOrMisuse",
    HaveMentalHealthProblem = "HaveMentalHealthProblem",
    IntellectualDevelopmentalProblem = "IntellectualDevelopmentalProblem",
    SocialEmotionalDeficitsInSocialInteractionAcrossMultipleContexts = "SocialEmotionalDeficitsInSocialInteractionAcrossMultipleContexts",
    ProblemOfAttentionOrHyperactivity = "ProblemOfAttentionOrHyperactivity",
    SpecialLearningProblem = "SpecialLearningProblem",
    DeficitsInCognitiveFunctions = "DeficitsInCognitiveFunctions",
    CaseAssessmentHallucination = "CaseAssessmentHallucination",
    CaseAssessmentDelusion = "CaseAssessmentDelusion",
    PersistentlyLowMood = "PersistentlyLowMood",
    AnxietyOrFearInGeneral = "AnxietyOrFearInGeneral",
    AnxietyOrFearRelatedToSeparation = "AnxietyOrFearRelatedToSeparation",
    ObsessionsAndCompulsions = "ObsessionsAndCompulsions",
    SeverelyTraumaticEvent = "SeverelyTraumaticEvent",
    AnxietyOrFearRelatedToSocialContact = "AnxietyOrFearRelatedToSocialContact",
    AnxietyOrFearRelatedHealthIssue = "AnxietyOrFearRelatedHealthIssue",
    SpecificPhobia = "SpecificPhobia",
    MoodSwingBetweenLowAndHigh = "MoodSwingBetweenLowAndHigh",
    FoodConsumptionProblem = "FoodConsumptionProblem",
    SleepProblems = "SleepProblems",
    ProblemRelatedToSex = "ProblemRelatedToSex",
    ProblemRelatedToSexOrientationOrGender = "ProblemRelatedToSexOrientationOrGender",
    PersonalityProblems = "PersonalityProblems",
    MentalHealthProblemOthers = "MentalHealthProblemOthers",
    HaveRelationalProblem = "HaveRelationalProblem",
    RelationalProblem = "RelationalProblem",
    AbuseAndNeglect = "AbuseAndNeglect",
    HaveEducationalAndOccupationalProblems = "HaveEducationalAndOccupationalProblems",
    EducationalAndOccupationalProblems = "EducationalAndOccupationalProblems",
    HousingAndEconomicProblems = "HousingAndEconomicProblems",
    ProblemsRelatedToCrimeOrInteractionWithLegalSystem = "ProblemsRelatedToCrimeOrInteractionWithLegalSystem",
    SuicideAttempt = "SuicideAttempt",
    ActiveThoughtsOrPlansWhichSuggestThereIsRiskOfSuicide = "ActiveThoughtsOrPlansWhichSuggestThereIsRiskOfSuicide",
    ProblemsWithAlcoholOrSubstanceMisuse = "ProblemsWithAlcoholOrSubstanceMisuse",
    ConcernFromOthersAboutRiskOfSuicide = "ConcernFromOthersAboutRiskOfSuicide",
    DrugsOverdosed = "DrugsOverdosed",
    CutOnPurpose = "CutOnPurpose",
    BurnedOnPurpose = "BurnedOnPurpose",
    HitOnPurpose = "HitOnPurpose",
    DrivenRecklesslyOnPurpose = "DrivenRecklesslyOnPurpose",
    ScratchedOnPurpose = "ScratchedOnPurpose",
    BeenPromiscuous = "BeenPromiscuous",
    EngagedInAbusiveRelationship = "EngagedInAbusiveRelationship",
    ExploitedFromBasicCare = "ExploitedFromBasicCare",
    OtherPlsSpecify = "OtherPlsSpecify",
    ViolentBehavior = "ViolentBehavior",
    ActiveThoughtsPlansOrSymptomsIndicatingARiskOfViolence = "ActiveThoughtsPlansOrSymptomsIndicatingARiskOfViolence",
    BehaviorSuggestingThereIsARiskOfPhysicalAndOrOrVerbalViolence = "BehaviorSuggestingThereIsARiskOfPhysicalAndOrOrVerbalViolence",
    ConcernFromOthersAboutRiskOfViolence = "ConcernFromOthersAboutRiskOfViolence",
    AbusiveBehaviorsTowardChildOrYouth = "AbusiveBehaviorsTowardChildOrYouth",
    AbusiveBehaviorsTowardElderly = "AbusiveBehaviorsTowardElderly",
    BeingAbusedByOthers = "BeingAbusedByOthers",
    HavePreviousContactWithAnyPsychiatricServiceInThePast = "HavePreviousContactWithAnyPsychiatricServiceInThePast",
    PreviousContactWithAnyPsychiatricServiceInThePast = "PreviousContactWithAnyPsychiatricServiceInThePast",
    HaveAdmissionToPsychiatricHospital = "HaveAdmissionToPsychiatricHospital",
    AdmissionToPsychiatricHospital = "AdmissionToPsychiatricHospital",
    AnySupportNetwork = "AnySupportNetwork",
    ResourcesAndStrengthsFamily = "ResourcesAndStrengthsFamily",
    ResourcesAndStrengthsRelative = "ResourcesAndStrengthsRelative",
    ResourcesAndStrengthsFriend = "ResourcesAndStrengthsFriend",
    ResourcesAndStrengthsReligiousCommunity = "ResourcesAndStrengthsReligiousCommunity",
    ResourcesAndStrengthsOthers = "ResourcesAndStrengthsOthers",
    NeedWellnessEnhancement = "NeedWellnessEnhancement",
    NeedPromotePersonalGrowthAndIndividuation = "NeedPromotePersonalGrowthAndIndividuation",
    NeedPromoteWellnessOfBeing = "NeedPromoteWellnessOfBeing",
    NeedPromoteLifeDirection = "NeedPromoteLifeDirection",
    NeedRelationshipEnrichment = "NeedRelationshipEnrichment",
    NeedWellnessEnhancementOther = "NeedWellnessEnhancementOther",
    NeedMentalHealthAssessmentAntPsychiatricService = "NeedMentalHealthAssessmentAntPsychiatricService",
    NeedConductMentalStateExamination = "NeedConductMentalStateExamination",
    NeedProvideSupportToFamilyMemberInCrisisSituation = "NeedProvideSupportToFamilyMemberInCrisisSituation",
    NeedArrangePsychiatricConsultationAndOrOrTreatment = "NeedArrangePsychiatricConsultationAndOrOrTreatment",
    NeedFacilitateOPDFollowUp = "NeedFacilitateOPDFollowUp",
    NeedMentalHealthAssessmentAntPsychiatricServiceOther = "NeedMentalHealthAssessmentAntPsychiatricServiceOther",
    NeedPsychoEducation = "NeedPsychoEducation",
    NeedPromoteKnowledgeOnMentalHealthAndMentalIllness = "NeedPromoteKnowledgeOnMentalHealthAndMentalIllness",
    NeedPromoteKnowledgeOnMedicationOrDrugAdherence = "NeedPromoteKnowledgeOnMedicationOrDrugAdherence",
    NeedPromoteKnowledgeOnRelapsePrevention = "NeedPromoteKnowledgeOnRelapsePrevention",
    NeedPromoteMentalHealthKnowledgeWithFamilyMember = "NeedPromoteMentalHealthKnowledgeWithFamilyMember",
    NeedPsychoEducationOther = "NeedPsychoEducationOther",
    NeedMentalHealthCoping = "NeedMentalHealthCoping",
    NeedImproveMentalAndOrOrEmotionalDistress = "NeedImproveMentalAndOrOrEmotionalDistress",
    NeedEnhanceCopingSkillsOnPsychiatricSymptom = "NeedEnhanceCopingSkillsOnPsychiatricSymptom",
    NeedImproveUndesirableInterpersonalRelationship = "NeedImproveUndesirableInterpersonalRelationship",
    NeedEnhanceSelfDifferentiationLevel = "NeedEnhanceSelfDifferentiationLevel",
    NeedNeedImproveMentalAndOrOrEmotionalDistressOther = "NeedNeedImproveMentalAndOrOrEmotionalDistressOther",
    NeedRecovery = "NeedRecovery",
    NeedInvolveFamilyMemberInRecoveryProcess = "NeedInvolveFamilyMemberInRecoveryProcess",
    NeedEnhanceSelfCareSkills = "NeedEnhanceSelfCareSkills",
    NeedEnhanceCommunityLivingSkills = "NeedEnhanceCommunityLivingSkills",
    NeedEnhanceInterpersonalSkills = "NeedEnhanceInterpersonalSkills",
    NeedExpandSocialNetworkAndOrOrInterests = "NeedExpandSocialNetworkAndOrOrInterests",
    NeedEnhanceStudiesOrEmploymentSkills = "NeedEnhanceStudiesOrEmploymentSkills",
    NeedEnhanceSkillsOnMoneyManagement = "NeedEnhanceSkillsOnMoneyManagement",
    NeedEnhanceProblemSolvingSkills = "NeedEnhanceProblemSolvingSkills",
    NeedEnhanceSkillsOnTimeManagement = "NeedEnhanceSkillsOnTimeManagement",
    NeedStructureDayTimeEngagementWithMeaningfulActivities = "NeedStructureDayTimeEngagementWithMeaningfulActivities",
    NeedEngageToOtherSocialResources = "NeedEngageToOtherSocialResources",
    NeedRecoveryOther = "NeedRecoveryOther",
    CaseReviewContactNature = "CaseReviewContactNature",
    CaseReviewJointVisitWith = "CaseReviewJointVisitWith",
    CaseReviewWellnessEnhancementGoalsAchieved = "CaseReviewWellnessEnhancementGoalsAchieved",
    CaseReviewMentalHealthAssessmentAndPsychiatricServiceGoalsAchieved = "CaseReviewMentalHealthAssessmentAndPsychiatricServiceGoalsAchieved",
    CaseReviewMentalHealthCopingGoalsAchieved = "CaseReviewMentalHealthCopingGoalsAchieved",
    CaseReviewRecoveryGoalsAchieved = "CaseReviewRecoveryGoalsAchieved",
    CaseReviewTentativeFUPlansOrFurtherAssessmentAreasGoalsAchieved = "CaseReviewTentativeFUPlansOrFurtherAssessmentAreasGoalsAchieved",
    CaseTerminationContactNature = "CaseTerminationContactNature",
    CaseTerminationJointVisitWith = "CaseTerminationJointVisitWith",
    CaseTerminationWellnessEnhancementGoalsAchieved = "CaseTerminationWellnessEnhancementGoalsAchieved",
    CaseTerminationMentalHealthAssessmentAndPsychiatricServiceGoalsAchieved = "CaseTerminationMentalHealthAssessmentAndPsychiatricServiceGoalsAchieved",
    CaseTerminationMentalHealthCopingGoalsAchieved = "CaseTerminationMentalHealthCopingGoalsAchieved",
    CaseTerminationRecoveryGoalsAchieved = "CaseTerminationRecoveryGoalsAchieved",
    CaseTerminationTentativeFUPlansOrFurtherAssessmentAreasGoalsAchieved = "CaseTerminationTentativeFUPlansOrFurtherAssessmentAreasGoalsAchieved",
    ReasonForCaseTermination = "ReasonForCaseTermination",
    CaseTerminationProposal = "CaseTerminationProposal",
    NoFurtherFollowUpByICCMW = "NoFurtherFollowUpByICCMW",
    CaseTerminationOrientation = "CaseTerminationOrientation",
    IndividualSupport = "IndividualSupport",
    ProgrammeSupport = "ProgrammeSupport",
    VolunteerSupport = "VolunteerSupport",
    ReferralToExternalService = "ReferralToExternalService",
    ContinuedPsychiatricTreatment = "ContinuedPsychiatricTreatment",
    CaseTerminationRecommend = "CaseTerminationRecommend",
    FamilyChecklistContactNature = "FamilyChecklistContactNature",
    FamilyChecklistType = "FamilyChecklistType",
    ReferralSource = "ReferralSource",
    ReferralPassedThroughAdultTeam = "ReferralPassedThroughAdultTeam",
    ReferralReason = "ReferralReason",
    PresentingProblemOfFamily = "PresentingProblemOfFamily",
    AssessedLevelOfNeedOrInitialResponseRequired = "AssessedLevelOfNeedOrInitialResponseRequired",
    PhysicalHealthAndSafety = "PhysicalHealthAndSafety",
    ResponsiveEmotionalCareStableAndSecureHomeLifeOrBase = "ResponsiveEmotionalCareStableAndSecureHomeLifeOrBase",
    EmotionalRegulationAndStressCoping = "EmotionalRegulationAndStressCoping",
    SelfEsteem = "SelfEsteem",
    Socialization = "Socialization",
    SchoolingAdjustmentAndMotivationForLearning = "SchoolingAdjustmentAndMotivationForLearning",
    HealthyExplorationAndExperimentationDailyLeisureActivities = "HealthyExplorationAndExperimentationDailyLeisureActivities",
    BehavioralLimitsBoundariesStructureRoutineAndConsistency = "BehavioralLimitsBoundariesStructureRoutineAndConsistency",
    ChildServiceAndSupportNeedsAssessmentOthers = "ChildServiceAndSupportNeedsAssessmentOthers",
    TreatmentOrmedicationOrProfessionalSupport = "TreatmentOrmedicationOrProfessionalSupport",
    PsychoEducation = "PsychoEducation",
    ParentingKnowledgeAndSkillDevelopment = "ParentingKnowledgeAndSkillDevelopment",
    PracticalNeeds = "PracticalNeeds",
    SocialSupport = "SocialSupport",
    OtherIssuesAffectingParenting = "OtherIssuesAffectingParenting",
    FamilyServiceAndSupportNeedsAssessmentOthers = "FamilyServiceAndSupportNeedsAssessmentOthers",
    CrisisOrEarlyInterventionOrRelapseOrViolenceOrSelfHarmFollowUpChecklist = "CrisisOrEarlyInterventionOrRelapseOrViolenceOrSelfHarmFollowUpChecklist",
    FamilyChecklistChildrenContactNature = "FamilyChecklistChildrenContactNature",
    FamilyChecklistChildrenType = "FamilyChecklistChildrenType",
    ChildDiagnosis = "ChildDiagnosis",
    UpdatedDiagnosisOfChild = "UpdatedDiagnosisOfChild",
    PresentingProblemsOfChild = "PresentingProblemsOfChild",
    AdverseChildhoodExperienceOfChild = "AdverseChildhoodExperienceOfChild",
    ChildInvolvedInIntervention = "ChildInvolvedInIntervention",
    InterventionForChild = "InterventionForChild",
    InterventionStageForChild = "InterventionStageForChild",
    ReasonsForChildNotInvolvedInIntervention = "ReasonsForChildNotInvolvedInIntervention",
    CaseRecordingContactNature = "CaseRecordingContactNature",
    CaseRecordingJointVisitWith = "CaseRecordingJointVisitWith",
    ConsultationType = "ConsultationType",
    ConsultationNature = "ConsultationNature",
    ConsultationFormat = "ConsultationFormat",
    ConsultationCP = "ConsultationCP",
    NatureOfConsultationOrConsultant = "NatureOfConsultationOrConsultant",
    CoWorkOrTransfer = "CoWorkOrTransfer",
    ReferTo = "ReferTo",
    ReasonsForReferralToOT = "ReasonsForReferralToOT",
    ReferralToIndividualSupport = "ReferralToIndividualSupport",
    OccupationStatus = "OccupationStatus",
    RequiredIndividualSupport = "RequiredIndividualSupport",
    SuggestedContactFrequency = "SuggestedContactFrequency",
    Needs = "Needs",
    ConsentOfClientHasBeenObtainedThatYourServicesVolunteerCanApproachForContact = "ConsentOfClientHasBeenObtainedThatYourServicesVolunteerCanApproachForContact",
    ConsentOfClientHasBeenObtainedThatYourServiceCanApproachForInformationRegardingTheProvisionOfService = "ConsentOfClientHasBeenObtainedThatYourServiceCanApproachForInformationRegardingTheProvisionOfService",
    ReferralTo = "ReferralTo",
    CPServiceStatus = "CPServiceStatus",
    CPServiceIntakeContactNature = "CPServiceIntakeContactNature",
    CPServiceIntakeBehavioralObservationTime = "CPServiceIntakeBehavioralObservationTime",
    CPServiceIntakeBehavioralObservationPhysicalAppearance = "CPServiceIntakeBehavioralObservationPhysicalAppearance",
    CPServiceIntakeBehavioralObservationGeneralManner = "CPServiceIntakeBehavioralObservationGeneralManner",
    CPServiceIntakeBehavioralObservationMobility = "CPServiceIntakeBehavioralObservationMobility",
    CPServiceIntakeBehavioralObservationAffect = "CPServiceIntakeBehavioralObservationAffect",
    CPServiceIntakeBehavioralObservationSpeechContent = "CPServiceIntakeBehavioralObservationSpeechContent",
    CPServiceIntakeBehavioralObservationCommunicativeness = "CPServiceIntakeBehavioralObservationCommunicativeness",
    PriorAndCurrentPsychologicalConsultation = "PriorAndCurrentPsychologicalConsultation",
    PriorAndCurrentPsychiatricConsultation = "PriorAndCurrentPsychiatricConsultation",
    FamilyHistoryOfPsychiatricIllness = "FamilyHistoryOfPsychiatricIllness",
    PriorAndCurrentMedicalProblem = "PriorAndCurrentMedicalProblem",
    OverallEmotionalOrBehavioralDisturbances = "OverallEmotionalOrBehavioralDisturbances",
    ImpairmentOfFunctioning = "ImpairmentOfFunctioning",
    SubjectiveDistress = "SubjectiveDistress",
    AmenabilityToCPTx = "AmenabilityToCPTx",
    MotivationForCPTx = "MotivationForCPTx",
    Ideation = "Ideation",
    Plans = "Plans",
    Gestures = "Gestures",
    Attempts = "Attempts",
    Threatened = "Threatened",
    Displayed = "Displayed",
    PriorSuicideHistory = "PriorSuicideHistory",
    PriorSubstanceAbuseHistory = "PriorSubstanceAbuseHistory",
    CPRecordingType = "CPRecordingType",
    CPRecordingContactNature = "CPRecordingContactNature",
    Format = "Format",
    OTServiceStatus = "OTServiceStatus",
    OTCaseJourney = "OTCaseJourney",
    OTTreatmentFocus = "OTTreatmentFocus",
    ServiceMode = "ServiceMode",
    ComplianceToDrugOrTreatment = "ComplianceToDrugOrTreatment",
    SideEffect = "SideEffect",
    CriminalRecord = "CriminalRecord",
    OTWorkAssessmentReport = "OTWorkAssessmentReport",
    Recommendation = "Recommendation",
    OTRecordingServiceMode = "OTRecordingServiceMode",
    SelfCare = "SelfCare",
    HealthCareManagement = "HealthCareManagement",
    HomeManagement = "HomeManagement",
    CommunityLivingSkills = "CommunityLivingSkills",
    PrevocationalTraining = "PrevocationalTraining",
    OTReviewServiceMode = "OTReviewServiceMode",
    DaytimeActivityStatus = "DaytimeActivityStatus",
    Cognitive = "Cognitive",
    IndependentLiving = "IndependentLiving",
    OTReviewHomeManagement = "OTReviewHomeManagement",
    CommunityLiving = "CommunityLiving",
    HealthManagement = "HealthManagement",
    VocationalSupport = "VocationalSupport",
    DayEngagementAndTraining = "DayEngagementAndTraining",
    Goal = "Goal",
    InterventionOrTraining = "InterventionOrTraining",
    OTServiceTerminationMode = "OTServiceTerminationMode",
    ReasonOfReferralToOTService = "ReasonOfReferralToOTService",
    RecievedOTServiceCognitive = "RecievedOTServiceCognitive",
    RecievedOTServiceActivityOfDailyLiving = "RecievedOTServiceActivityOfDailyLiving",
    RecievedOTServiceHomeManagement = "RecievedOTServiceHomeManagement",
    RecievedOTServiceCommunityLiving = "RecievedOTServiceCommunityLiving",
    RecievedOTServiceHealthManagement = "RecievedOTServiceHealthManagement",
    RecievedOTServiceDayTraining = "RecievedOTServiceDayTraining",
    RecievedOTServiceVocationalSupport = "RecievedOTServiceVocationalSupport",
    OTServiceTerminationReferralTo = "OTServiceTerminationReferralTo",
    CompletedOTService = "CompletedOTService",
    UnsuccessfulDischarge = "UnsuccessfulDischarge",
    RSCRecordingContactNature = "RSCRecordingContactNature",
    CaseRSCRecordingType = "CaseRSCRecordingType",
    EmploymentStatus = "EmploymentStatus",
    AreYouLivingWithFamilyMemberWithMentallyIllness = "AreYouLivingWithFamilyMemberWithMentallyIllness",
    DoYouHaveChronicDiseases = "DoYouHaveChronicDiseases",
    DoYouKnowTheDiagnosisOfYourFamilyMember = "DoYouKnowTheDiagnosisOfYourFamilyMember",
    DoYouKnowTheMedicationOfYourFamilyMember = "DoYouKnowTheMedicationOfYourFamilyMember",
    WhatDoYouThinkAboutTheCauseOfTheMentalIllnessOfYourFamilyMember = "WhatDoYouThinkAboutTheCauseOfTheMentalIllnessOfYourFamilyMember",
    YourMainCaringParts = "YourMainCaringParts",
    WhetherFamilyMembersAreSuspectedPatients = "WhetherFamilyMembersAreSuspectedPatients",
    HasFamilyMemberWithSuspectedMentalIllnessOrWithMentalIllnessExertedViolence = "HasFamilyMemberWithSuspectedMentalIllnessOrWithMentalIllnessExertedViolence",
    HaveYouExertedViolenceAgainstFamilyMemberWithSuspectedMentalIllnessOrWithMentalIllness = "HaveYouExertedViolenceAgainstFamilyMemberWithSuspectedMentalIllnessOrWithMentalIllness",
    HaveYouanyAttemptForSelfharmOrSuicideDueToCaringStress = "HaveYouanyAttemptForSelfharmOrSuicideDueToCaringStress",
    IsThereAnyoneThatYouCanTalkAndShareTheCaringStress = "IsThereAnyoneThatYouCanTalkAndShareTheCaringStress",
    HaveYouReceivedAnySocialServies = "HaveYouReceivedAnySocialServies",
    HowManyFamilyMembersAreResponsibleForYourCare = "HowManyFamilyMembersAreResponsibleForYourCare",
    WhatIsTheImpactLevelOnYourDailyLifeDueToYourCaringResponsiblity = "WhatIsTheImpactLevelOnYourDailyLifeDueToYourCaringResponsiblity",
    InPastFourweeksHaveYouAlways = "InPastFourweeksHaveYouAlways",
    HowOftenDoYouThinkTheNursingPlanForSuspectedMentalIllness = "HowOftenDoYouThinkTheNursingPlanForSuspectedMentalIllness",
    CaseRecordAndSituationGender = "CaseRecordAndSituationGender",
    CaseRecordAndSituationEducationLevel = "CaseRecordAndSituationEducationLevel",
    CaseRecordAndSituationStudyWorkUnemployment = "CaseRecordAndSituationStudyWorkUnemployment",
    EarlyPsychosis = "EarlyPsychosis",
    FirstMedication = "FirstMedication",
    SecondMedication = "SecondMedication",
    ImpactLevel = "ImpactLevel",
    OccurrenceRate = "OccurrenceRate",
    MainContactViaWhatsapp = "MainContactViaWhatsapp",
    MainContactViaSignal = "MainContactViaSignal",
    OtherContactViaWhatsapp = "OtherContactViaWhatsapp",
    OtherContactViaSignal = "OtherContactViaSignal",
    MemberInfoTag = "MemberInfoTag",
    PlaceOfBirth = "PlaceOfBirth",
    Ethnicity = "Ethnicity",
    Religion = "Religion",
    Language = "Language",
    Accommodation = "Accommodation",
    Occupation = "Occupation",
    TypeOfSchoolOrCompany = "TypeOfSchoolOrCompany",
    SourceOfIncome = "SourceOfIncome",
    NewsletterSubscription = "NewsletterSubscription",
    ReceiveVia = "ReceiveVia",
    Newsletter = "Newsletter",
    CategoryOfCaregivers = "CategoryOfCaregivers",
    ProgramPreferenceList = "ProgramPreferenceList",
    WaitingForService = "WaitingForService",
    LearnRefreshPlatformBy = "LearnRefreshPlatformBy",
    CaringGroup = "CaringGroup",
    ReasonForExit = "ReasonForExit",
    Relationship = "Relationship",
    CurrentMentalHealthIssue = "CurrentMentalHealthIssue",
    CurrentCondition = "CurrentCondition",
    FamilyMemberAccommodation = "FamilyMemberAccommodation",
    FinancialSupport = "FinancialSupport",
    PreferredServiceDistrict = "PreferredServiceDistrict",
    WhichOfTheFollowingBestDescribeYourself = "WhichOfTheFollowingBestDescribeYourself",
    TalentsOrSkills = "TalentsOrSkills",
    TargetGroup = "TargetGroup",
    PreferredVolunteeringServices = "PreferredVolunteeringServices",
    ExpectedNatureOfService = "ExpectedNatureOfService",
    ExpectedDurationOfParticipation = "ExpectedDurationOfParticipation",
    HowDoYouKnowOurService = "HowDoYouKnowOurService",
    VolunteerRole = "VolunteerRole",
    InterviewResult = "InterviewResult",
    ServiceStatus = "ServiceStatus",
    NonCaseRecordingNatureOfContact = "NonCaseRecordingNatureOfContact",
    NonCaseRecordingNonCaseWork = "NonCaseRecordingNonCaseWork",
    NonCaseReviewNatureOfContact = "NonCaseReviewNatureOfContact",
    JointVisitWith = "JointVisitWith",
    SSTSummaryNatureOfContact = "SSTSummaryNatureOfContact",
    SSTSummaryAdditional = "SSTSummaryAdditional",
    EvaluationRecordType = "EvaluationRecordType",
    TypesOfSupport = "TypesOfSupport",
    IndividualAndVolunteerSupport = "IndividualAndVolunteerSupport",
    IndividualAndVolunteerSupportManualInputFrequency = "IndividualAndVolunteerSupportManualInputFrequency",
    Building = "Building",
    Estate = "Estate",
    Street = "Street",
    ICCMWStatType = "ICCMWStatType",
}

export enum PersonalInformationPermission {
    MiniVersion = "MiniVersion",
    FullAccess = "FullAccess",
}

export enum NonCaseworkOrCaseworkPermission {
    NoAccess = "NoAccess",
    ReadOnly = "ReadOnly",
    FullAccess = "FullAccess",
}

export interface CreateVolunteerMeetingRecordCommand {
    memberInfoId?: string | undefined;
    memberNo?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    venue?: string | undefined;
    volunteerProject?: string | undefined;
    nature?: string | undefined;
    responsibleWorker?: string | undefined;
    serviceDistrictOrName?: string | undefined;
    volunteerId?: number;
    natureOfContact?: string | undefined;
    objectives?: string | undefined;
    content?: string | undefined;
    memberMentalState?: string | undefined;
    summary?: string | undefined;
    pointToTakeNote?: string | undefined;
    suggestedFutureAction?: string | undefined;
    futureActionOrPlan?: string | undefined;
    approvedByStaff?: boolean;
    noCaseWork?: string | undefined;
    websiteId?: string | undefined;
}

export interface UpdateVolunteerMeetingRecordCommand {
    id?: string;
    memberInfoId?: string | undefined;
    memberNo?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    venue?: string | undefined;
    volunteerProject?: string | undefined;
    nature?: string | undefined;
    responsibleWorker?: string | undefined;
    serviceDistrictOrName?: string | undefined;
    volunteerId?: number;
    natureOfContact?: string | undefined;
    objectives?: string | undefined;
    content?: string | undefined;
    memberMentalState?: string | undefined;
    summary?: string | undefined;
    pointToTakeNote?: string | undefined;
    suggestedFutureAction?: string | undefined;
    futureActionOrPlan?: string | undefined;
    approvedByStaff?: boolean;
    noCaseWork?: string | undefined;
    websiteId?: string | undefined;
}

export interface CreatePSWCommand {
    id?: string;
    memberNo?: string;
    startTime?: Date;
    endTime?: Date;
    venue?: string | undefined;
    volunteerProject?: string | undefined;
    nature?: string | undefined;
    responsibleWorker?: string | undefined;
    serviceDistrictOrName?: string | undefined;
    volunteerName?: string | undefined;
    natureOfContact?: string | undefined;
    objectives?: string | undefined;
    content?: string | undefined;
    memberMentalState?: string | undefined;
    summary?: string | undefined;
    pointToTakeNote?: string | undefined;
    suggestedFutureAction?: string | undefined;
    futureActionOrPlan?: string | undefined;
    approvedByStaff?: boolean;
    noCaseWork?: string | undefined;
    pswType?: string | undefined;
    serviceObjectType?: string | undefined;
}

export interface UpdatePSWCommand {
    id?: string;
    startTime?: Date;
    endTime?: Date;
    venue?: string | undefined;
    volunteerProject?: string | undefined;
    nature?: string | undefined;
    responsibleWorker?: string | undefined;
    serviceDistrictOrName?: string | undefined;
    volunteerName?: string | undefined;
    natureOfContact?: string | undefined;
    objectives?: string | undefined;
    content?: string | undefined;
    memberMentalState?: string | undefined;
    summary?: string | undefined;
    pointToTakeNote?: string | undefined;
    suggestedFutureAction?: string | undefined;
    futureActionOrPlan?: string | undefined;
    approvedByStaff?: boolean;
    noCaseWork?: string | undefined;
    pswType?: string | undefined;
    serviceObjectType?: string | undefined;
}

export interface MembershipTypeDto extends BaseAuditableEntityOfInteger {
    name?: string;
    hasCase?: boolean;
    canBecomePrincipal?: boolean;
    canBecomeSubsidiary?: boolean;
    canInputICCMWStat?: boolean;
}

export interface SurveyFirstAndLastDto {
    id?: string;
    formName?: string;
    formType?: AssessmentType;
    surveyVersionId?: number;
    content?: string | undefined;
    firstCreated?: Date;
    lastCreated?: Date;
    assessmentItemDetails?: SurveyAssessmentCriteriaDetailDto[];
}

export enum AssessmentType {
    ClinicalOrCaseAssessment = "ClinicalOrCaseAssessment",
    RecoveryAssessment = "RecoveryAssessment",
    VolunteerAssessment = "VolunteerAssessment",
    SBUAssessmentResults = "SBUAssessmentResults",
    VolunteerEvaluationRecord = "VolunteerEvaluationRecord",
    VolunteerFeedbackForm = "VolunteerFeedbackForm",
    OtherSurveyOrQuestionnaire = "OtherSurveyOrQuestionnaire",
}

export interface SurveyAssessmentCriteriaDetailDto {
    assessmentItem?: string;
    firstScore?: string | undefined;
    firstResult?: string | undefined;
    firstWorker?: string | undefined;
    lastScore?: string | undefined;
    lastResult?: string | undefined;
    lastWorker?: string | undefined;
}

export enum AssessmentType2 {
    ClinicalOrCaseAssessment = 0,
    RecoveryAssessment = 1,
    VolunteerAssessment = 2,
    SBUAssessmentResults = 3,
    VolunteerEvaluationRecord = 4,
    VolunteerFeedbackForm = 5,
    OtherSurveyOrQuestionnaire = 6,
}

export interface MemberSurveyDto extends BaseAuditableEntityOfInteger {
    assessmentName?: string;
    survey?: SurveyDto;
    userId?: number | undefined;
    resultJson?: string;
    content?: string | undefined;
    memberNo?: string;
    chineseName?: string;
    individualAndVolunteerSupportId?: number | undefined;
    individualAndVolunteerSupportType?: string | undefined;
    status?: boolean | undefined;
    responsibleWorkerUserId?: string | undefined;
    responsibleWorkerUserEnglishName?: string | undefined;
}

export interface SurveyDto extends BaseAuditableEntityOfString {
    formName?: string;
    formType?: AssessmentType;
    formTypeName?: string;
    url?: string | undefined;
    password?: string | undefined;
    content?: string | undefined;
    isDelete?: boolean;
    isEnabled?: boolean;
    surveyAssessmentCriterias?: SurveyAssessmentCriteriaDto[];
}

export interface SurveyAssessmentCriteriaDto {
    id?: number;
    assessmentItem?: string;
    scoreJsonPath?: string | undefined;
    resultJsonPath?: string | undefined;
}

export interface SurveyVersionDetailDto extends BaseAuditableEntityOfInteger {
    surveyId?: string;
    formName?: string;
    content?: string | undefined;
}

export interface PaginatedListOfMemberSurveyLabelDto {
    items?: MemberSurveyLabelDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface MemberSurveyLabelDto extends BaseAuditableEntityOfInteger {
    assessmentName?: string;
    userId?: number | undefined;
}

export interface PaginationRequest {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    isOrderByAscending?: boolean;
}

export interface SearchMemberSurveyHistorysWithPaginationQuery extends PaginationRequest {
    surveyId?: string;
    memberInfoId?: string;
    orderBy?: string;
}

export interface PaginatedListOfMemberSurveyDto {
    items?: MemberSurveyDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface SearchMemberSurveysWithPaginationQuery extends PaginationRequest {
    memberInfoId?: string;
    formType?: AssessmentType;
    orderBy?: string;
}

export interface CreateMemberSurveyCommand {
    surveyId?: string;
    memberInfoId?: string;
    resultJson?: string;
    individualAndVolunteerSupportId?: number | undefined;
    status?: boolean | undefined;
}

export interface UpdateMemberSurveyCommand {
    id?: number;
    resultJson?: string;
    individualAndVolunteerSupportId?: number | undefined;
    status?: boolean | undefined;
}

export interface PaginatedListOfSurveyDto {
    items?: SurveyDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface SearchSurveysWithPaginationQuery extends PaginationRequest {
    formName?: string | undefined;
    formType?: AssessmentType | undefined;
    isEnabled?: boolean | undefined;
    evaluationRecordType?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    orderBy?: string;
}

export interface AssessmentTypeDto {
    value?: number;
    name?: string;
}

export interface PaginatedListOfUserProfileVm {
    items?: UserProfileVm[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface UserProfileVm {
    userId?: string;
    email?: string;
    chineseName?: string | undefined;
    englishName?: string | undefined;
}

export interface VolunteerProgramVm {
    volunteerProgramId?: number;
    volunteerProject?: string;
    serviceDistrictOrItems?: string;
    serviceStatus?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    serviceMembers?: MemberInfoNameDto[];
}

export interface MemberInfoNameDto {
    id?: string;
    memberNo?: string;
    chineseName?: string | undefined;
    englishName?: string | undefined;
    ageAdmitted?: number | undefined;
    ageCurrent?: number | undefined;
    mainContactNumber?: string | undefined;
    otherContactNumber?: string | undefined;
    nickname?: string | undefined;
    emailAddress?: string | undefined;
}

export interface VolunteerTotalServiceHourVm {
    volunteerPracticumHours?: PaginatedListOfVolunteerPracticumHourVm;
    accumulatePracticumHours?: number;
    thisYearAllAccumulatePracticumHours?: number;
    thisYearApprovedAccumulatePracticumHours?: number;
    thisYearNotApprovedAccumulatePracticumHours?: number;
}

export interface PaginatedListOfVolunteerPracticumHourVm {
    items?: VolunteerPracticumHourVm[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface VolunteerPracticumHourVm {
    volunteerPracticumHourId?: string;
    volunteerProject?: string;
    serviceDistrictOrItems?: string;
    startDate?: Date;
    endTime?: Date;
    praticumHours?: number;
    activitieSubmitDate?: Date;
}

export interface CreateVolunteerPracticumHourCommand {
    volunteerId?: number;
    startTime?: Date;
    endTime?: Date;
    volunteerProgramId?: number;
    approvedByWorker?: boolean | undefined;
    isTrainingPracticum?: boolean;
    serviceDistrictOrNameOthers?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}